import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

export const MainNav: React.FC = () => {
  const location = useLocation();

  let activeSection = "";
  if (location.pathname.indexOf("/messages/") > -1) activeSection = "messages";
  else if (location.pathname.indexOf("/playlists/") > -1) activeSection = "playlists";
  else if (location.pathname.indexOf("/screens/") > -1) activeSection = "screens";

  const getLinkClass = (sectionName: string) => {
    if (sectionName === activeSection) return "nav-link active";
    else return "nav-link"
  }

  return (
    <>
      <div id="mainNav" data-testid="main-navigation">
        <div className="container-fluid">
          <Row>
            <Col xs={4} className="text-center" style={{ borderRight: "1px solid #FFF" }} >
              <Link to="/messages/" className={getLinkClass("messages")} id="mainNavMessages" data-testid="nav-messages"><i className="far fa-image"></i></Link>
            </Col>
            <Col xs={4} className="text-center" style={{ borderRight: "1px solid #FFF" }} >
              <Link to="/playlists/" className={getLinkClass("playlists")} id="mainNavPlaylists" data-testid="nav-playlists"><i className="fas fa-list-ul"></i></Link>
            </Col>
            <Col xs={4} className="text-center" >
              <Link to="/screens/" className={getLinkClass("screens")} id="mainNavScreens" data-testid="nav-screens"><i className="fas fa-tv"></i></Link>
            </Col>
          </Row >
        </div >
      </div >
      <div id="mainNavAfter"></div>
    </>
  );
};